export function Logo() {
  return (
    <div className="logo">
      <span role="img" alt="img">
        🍿
      </span>
      <h1>IMDBMovies</h1>
    </div>
  );
}
